import React from "react"
import { StaticQuery, graphql } from "gatsby"

const IndexPage = () => (
  <StaticQuery
    query={graphql`
      query {
        metaJson {
          slug
        }
      }
    `}
    render={(data) => {
      if (typeof window !== `undefined`) {
        const fallback = data.metaJson?.slug || `abraham`
        const target = localStorage.getItem('lastLesson') || fallback
        window.location.replace(`/${target}`)
      }
      return <></>
    }}
  />
)

export default IndexPage
